const CN = {
  //todo: studentPaymentPlan Page
  Student: '学生',
  Name: '名字',
  No: '无',
  'No Sibling': '没有兄弟姐妹',
  Siblings: '兄弟姐妹',
  Parent: '家长',
  Payment: '付款',
  test: '付款',
  'Student Name': '学生姓名',
  'Student FIN No': '学生FIN号码',
  'Company Name': '公司名称',
  'Company Address': '公司地址',
  Email: '电子邮件',
  email: '电子邮件',
  Mother: '母亲',
  mother: '母亲',
  father: '父亲',
  Father: '父亲',
  guardian: '监护人',
  Guardian: '监护人',
  'Third Party': '第三方',
  Number: '编号',
  NO: '号码',
  'Meal Preferences': '饮食首选',
  Class: '班级',
  Programme: '课',
  Payee: '付款人',
  Family: '家庭',
  List: '名单',
  Page: '页',
  Info: '资料',
  'info not found': '资料不存在',
  Preview: '预览',
  Generate: '创建',
  'No Data Found': '没有找到数据',
  Invoice: '单据',
  Receipt: '收据',
  Show: '显示',
  Transaction: '交易',
  Refund: '退款',
  'Credit Note': '信用票据',
  'Re-Invoice': '重新发票',
  Action: '操作',
  'Transactions History': '交易记录',
  'CN/Receipt': '信用票据/收据',
  Document: '文件',
  Reminder: '提醒',
  Reprint: '重印',
  'Apply Payment Plan': '申请付款计划',
  'View Payment Plan': '查看付款计划',
  'Payment Plan': '付款计划',
  Start: '开始',
  Date: '日期',
  'Pro-Rate Fees': '按比例收费',
  'Add Discount Plan': '添加折扣',
  'Sibling Discount': '兄弟姐妹折扣',
  'Payment Plan Details': '付款计划详情',
  'Creation Date': '创建日期',
  'Creation By': '创建者',
  Level: '班级',
  'Fee Scheme Name': '费用名称',
  'Validity Starts On': '有效期开始于',
  'Validity Ends On': '有效期结束于',
  'Tax Applicable': '税务适用',
  Tax: '税',
  Center: '中心',
  Currency: '货币',
  Status: '状态',
  'History Detail': '详细日志',
  Remarks: '备注',
  CN: '信用票据',
  RECEIPTS: '收据',
  Mode: '模式',
  'Cheque/DD No': '支票号码',
  'Bank Name': '银行名称',
  'Pick a day': '选择日期',
  'Add Item': '添加项目',
  'Pay Amount': '支付金额',
  'Does this receipt required Invoice': '此收据是否需要发票',
  Cancel: '取消',
  INVOICING: '开票',
  'Print monthly breakdown': '打印每月细目',
  'Payment Due Date': '到期付款',
  'Apply Discount plan': '申请折扣',
  'Over Payment': '超出付款',
  'GST Value': '消费税',
  GST: '消费税',
  'Total Amount': '总金额',
  'Generate Receipt Detail(With Transaction History)': '收据详细信息（使用交易记录)',
  'Transaction History Detail': '交易记录详情',
  'Left Over Payment': '剩余付款',
  Amount: '金额',
  'Included GST': '包括消费税',
  OVERPAYMENT: '多余付款',
  'There are ': '您的',
  'overpayment items in your selection': '选择中有多付项目',
  Proceed: '继续',
  Yes: '是',
  'No ': '不是',
  'Email To': '邮件至',
  Title: '标题',
  Description: '描述',
  Send: '发送',
  Overview: '总览',
  To: '至',
  Address: '地址',
  'First Name': '名字',
  'Last Name': '姓',
  'Registration Date': '注册日期',
  'Center Name': '中心名称',
  Details: '详细信息', // 详情,
  'Payment Date': '付款日期',
  'Item Description': '项目描述',
  'GST Applicable': '税务适用',
  'Docs Status': '文档状态',
  'Docs Type': '文档类型',
  Total: '总计',
  'Total(IncludedGst)': '总计(包括消费税)',
  'Invoice Name': '发票名称',
  'Invoice Date': '发票日期',
  'Invoice Amount': '发票金额',
  'Outstanding Amount': '未付款项',
  'Invoice Due Date': '发票到期日',
  'Transaction Type': '文档类型',
  'Document Number': '文档号码',
  'Document Status': '文档状态',
  'Total (Incl. GST)': '总计(包括消费税)',
  'Created By': '创建者',
  'Payment Schedule': '付款时间表',
  Timeline: '时间轴',
  'Item Type': '项目类型',
  'Item Name': '项目名称',
  'Calculation category': '计算类别',
  Message: '讯息',
  'Payment item cannot be deleted': '支付项目不能被删除',
  Delete: '删除',
  More: '更多',
  'Invoice To': 'Invoice To',
  //todo: studentPaymentPlan Page

  //todo: Homepage
  Students: '学生',
  'NEW STUDENT': '新学生',
  'VIEW ALL': '查看全部',
  CLASSES: '班级',
  'STUDENT LIST': '学生名单',
  'Student List': '学生名单',
  'New Enrollment': '新注册',
  Withdraw: '退出',
  Transferred: '转让',
  Statistic: '统计',
  'No Record Yet': '还没有记录',
  'Student Forecast': '学生预测',
  Month: '月',
  'Student Movement': '学生调动',
  'Student Attendance': '学生签到',
  'Please Wait': '请稍等',
  'Search Class': '班级搜索',
  'Total Present': '出席总数',
  'Total Not Present': '缺席总数',
  'Total Students': '学生总数',
  'Students by level': '按级别分类的学生',
  Present: '出席',
  'Not Present': '缺席',
  January: '一月',
  February: '二月',
  March: '三月',
  April: '四月',
  May: '五月',
  June: '六月',
  July: '七月',
  //todo: Homepage

  //todo studentListPayment page
  'Student NO': '学生编号',
  'Student First Name': '学生名',
  'Student Last Name': '学生姓氏',
  Select: '选择',
  'Parent Name': '家长姓名',
  Search: '搜索',
  Filter: '过滤器',
  'PLEASE SEARCH TO VIEW LIST': '请搜索查看列表',
  'Guided Tour': '引导按钮',
  UpdateLevelClass: '更新级别类别',
  'Student Information': '学生资料',
  Blacklist: '黑名单',
  Graduated: '毕业',
  Waitlist: '等候列表',
  Void: '无效',
  Withdrawn: '撤消',
  Pending: '待定',
  Active: '活跃',
  Closed: '关闭',
  'Student ID': '学生证',
  '': '',
  '': '',
  '': '',
  '': '',
  '': '',
  '': '',
  '': '',
  //todo studentListPayment page

  //todo studentCourseList
  'Commencement Date': '生效日期',
  '': '',
  '': '',
  '': '',
  '': '',
  '': '',
  '': '',
  '': '',
  //todo studentCourseList

  //todo NewFeed Page
  NewFeed: '动态消息',
  Newfeed: '动态消息',
  Feed: '动态消息',
  Edit: '编辑',
  Profile: '个人资料',
  Photo: '照片',
  // "Attendance":"出席率",
  Report: '报告',
  Result: '成果',
  item: '项目',
  one: '一',
  two: '二',
  three: '三',
  'ARE YOU SURE': '你确定吗?',
  PROFILE: 'PROFILE ',
  PHOTO: 'PHOTO ',
  "Once you delete a post, you can't undo it": '删除帖子后，您将无法撤消它。',
  'Feed Not Found': '未发布帖子',
  BROWSE: '浏览',
  Teacher: '老师',
  'My Post': '我的帖子',
  'All Post': '全部帖子',
  'New Post': '新建帖子',
  Hashtag: 'Hashtag',
  "Please type in your word without '#'. Add your tag one per line.": "请输入不带'＃'的单词。每行添加一个标签。",
  '* use hashtag moments or Moments for post to appear under parent Moments.': '*使用hashtag moments或Moments进行发布，以显示在家长Moments的页面。',
  'All Moments Post': '全部Moments帖子',
  'Search Moment': '搜索学生动态',
  //todo NewFeed Page

  //todo singleFeedComponent Page
  Post: '帖子',
  LIKE: '赞',
  LOVE: '爱心',
  WOW: '哇',
  HAHA: '哈哈',
  SAD: '伤心',
  'Write a comment': '发表评论',
  'More Comment': '更多评论',
  Comment: '评语',
  'Load More': '加载',
  'Seen by': 'Seen by',
  //todo singleFeedComponent Page

  //todo Gallery Page
  Create: '创建',
  new: 'new ',
  folder: '文件夹',
  Upload: '上载',
  //"Select":"Select ",
  All: '全部',
  Unselect: '取消选择',
  Download: '下载',
  View: '查看',
  Move: '移动',
  'Post as learning moment': '发布为学习瞬间',
  'Post as Updates': '发布更新',
  Remove: '去除',
  Back: '返回',
  Rename: '重新命名',
  Portfolio: '作品集',
  Updates: '更新',
  Folder: '文件夹',
  'Are you sure you want to delete the folder and the selected image(s)': '您确定要删除文件夹和选定的图像吗？', // 您确定要删除文件夹和选定的图像吗？
  'Are you sure you want to delete the selected image(s)': '您确定要删除所选的图像吗？', // 您确定要删除所选的图像吗
  'Are you sure you want to remove the folder': '您确定要删除该文件夹吗？', // 您确定要删除该文件夹吗
  'Go Back': 'Go Back',
  'Drop file(s) here to upload': '将文件拖放到此处进行上传', // 将文件拖放到此处进行上传
  New: '新',
  Item: '项目',
  Confirm: '确认',
  'Move item(s) to': 'Move item(s) to',
  //todo Gallery Page

  //todo NewBroadCast Page
  Broadcast: '广播',
  BROADCAST: '广播',
  Import: '导入',
  Image: '图像',
  By: '通过',
  'Choose a file': '选择一个文件',
  'REMOVE ALL': '全部删除',
  Content: '详情',
  'Please enter a title': '请输入标题',
  Submit: '提交',
  'Please contact Kagami administrator': '请联系Kagami管理员',
  'Select File(s)': '选择文件',
  'Submission Successful': '提交成功',
  'Broadcast Added': '广播已添加',
  'Broadcast List': '广播列表',
  'Broadcast Details': '广播详情',
  'Read More': '更多',
  //todo NewBroadCast Page

  //todo sidebar Component
  Notifications: '通知',
  Event: '学校活动',
  Material: '材料',
  Media: '媒体',
  Add: '添加',
  // "":"",
  Close: '关闭',
  'Post Feed Msg': ' 在动态消息中发布了新帖子.',
  'Post Comment Feed Msg': ' 评论您的帖子.',
  'Post Broadcast Msg': ' 在广播中发布了新广播.',
  'Post Portfolio Msg': ' posted new moments in Moments.',
  'Notif Empty Message': '没有通知',
  'Not Found': '没找到',
  'Travel Declaration': '旅行申报表',
  'Click here to watch the tutorial': '单击此处观看教程',
  //todo sidebar Component

  //todo NewMedia page
  Gallery: '图库',
  Selected: '选择',
  'Whoops. Something went wrong': '糟糕。 出了点问题',
  'Please check your fields and try again': 'Please check your fields and try again',
  'Please enter folder name': '请输入文件夹名称',
  'Download Selected': '下载选中内容',
  'New Folder': '创建文件夹',
  'Move To': '移至',
  'Learning Journey': '学习之旅',
  'Unselect All': '取消选择',
  OK: '好的',
  'Please confirm you want to delete the selected media': '选中的图片删除后将无法恢复，您确定要删除吗？',
  Moment: 'Moment',
  'Learning Moment': 'Learning Moment',
  //todo NewMedia page

  //todo Attendance List Page
  Attendance: '出勤率',
  'Thermal Scanner Import': '热扫描仪导入',
  'Parents Contact': '家长联络',
  'Pickup Mode': '接送模式',
  ECA: 'ECA',
  Nil: '没有',
  Save: '保存',
  Import: '导入',
  'Please select Class...': '请选择班级...',
  'No Student Found...': '找不到学生...',
  'Select Class': '选择班级',
  'Select Attendance For All': '选择所有人',
  ECA: '课外活动',
  Present: '出席/到位',
  Absent: '缺席',
  Late: '迟到',
  Sick: '病假',
  'On Holiday': '度假',
  'Sent Home': '回家',
  Require: '需求',
  'Please at least tick at least one row to update': '请至少勾选至少一行以进行更新',
  Error: '错误',
  'Error! Please try again later': '错误！ 请稍后再试',
  Success: '成功',
  'Successfully saved': '保存成功',
  //todo Attendance List Page

  //todo bus attendance poge
  'Attendance Remark': '出席备注',
  'Show Mobile': '显示手机号码',
  'Class (Level)': '班级（级别）',
  ' was copied to the clipboard.': '已复制到剪贴板。',
  //todo bus attendance poge

  //todo daily routine
  'Daily Routine': '日志',
  'Mass Update': '批量更新',
  'Please select a student ...': '选择学生',
  'Select Student': '选择学生',
  'Select Status': '选择状态',
  'Select Activity': '选择活动',
  Rest: '休息',
  Nap: '午觉',
  Sleep: '睡觉',
  Remark: '备注',
  'Bottle-Type': 'Bottle-Type',
  Solid: '婴儿辅食',
  'Latch On': 'Latch On',
  Menu: 'Menu',
  Formula: '奶粉',
  'Breast Milk': '母乳',
  Left: '左边',
  Right: '右边',
  Poop: 'Poop',
  Texture: '质地',
  Creamy: '奶油状',
  Firm: 'Firm',
  Hard: '硬状',
  Watery: '液状',
  Hygiene: '卫生',
  'Diaper change': '换尿布',
  'Shower&Diaper change': '沐浴和换尿布',
  Shower: '沐浴',
  Brown: '褐色',
  Tan: '浅褐色',
  Yellow: '黄色',
  Green: '绿色',
  Black: '黑色',
  Color: '颜色',
  'Todays Activity': '今日活动',
  'Rest|Nap': '休息>午觉',
  'Rest|Sleep': '休息>睡觉',
  'Feed|Bottle-Type|Formula': '喂食>Bottle-Type>奶粉',
  'Feed|Bottle-Type|Breast Milk': '喂食>Bottle-Type>母乳',
  'Feed|Solid': '喂食>婴儿辅食',
  'Feed|Latch On|Left': '喂食>Latch On>左边',
  'Feed|Latch On|Right': '喂食>Latch On>右边',
  'Feed|Menu': '喂食>Menu',

  'Poop|Texture|Creamy': 'Poop>质地>奶油状',
  'Poop|Texture|Firm': 'Poop>质地>Firm',
  'Poop|Texture|Hard': 'Poop>质地>硬状',
  'Poop|Texture|Watery': 'Poop>质地>液状',
  'Poop|Color|Brown': 'Poop>颜色>褐色',
  'Poop|Color|Tan': 'Poop>颜色>浅褐色',
  'Poop|Color|Yellow': 'Poop>颜色>黄色',
  'Poop|Color|Green': 'Poop>颜色>绿色',
  'Poop|Color|Black': 'Poop>颜色>黑色',

  'Hygiene|Diaper change': '卫生>换尿布',
  'Hygiene|Shower&Diaper change': '卫生>沐浴和换尿布',
  'Hygiene|Shower': '卫生>沐浴',
  'Select All': '全选',
  Update: '更新',
  'Daily Routine Mass Update': '日志批量更新',
  'View Activity': '查看活动',
  Activity: '活动',
  Activities: '活动',
  'Back to Student List': '返回',
  From: '从',
  'Get Start Time': '开始时间',
  'End Time': '结束时间',
  //todo daily routine

  //todo menu
  Administration: '出勤表',
  'Bus Attendance': '巴士出勤表',
  'Class Attendance': '班级出勤表',
  'Daily Routine': '日志',
  'ECA Attendance': '课外活动出勤表',
  Logout: '登出',
  'My Account': '我的帐户',
  English: 'English',
  Chinese: '中文',
  'Bus Management': '巴士管理',
  'Class Management': '班级管理',
  'ECA Management': '课外活动管理',
  'Attendance Master': '出勤管理',
  'Cancel Schedule': '取消时间表',
  Parents: '家长',
  'Parent Search': '家长搜索',
  Reports: '报告',
  'Attendance Report': '出勤报告',
  'Class Attendance Report': '课堂出勤报告',
  'Student List Report': '学生名单报告',
  'Advance Search': '搜寻学生',
  'Create Student': '创建学生资料',
  //todo menu

  //todo my account

  'Reset Password': '密码更新',
  'Your password needs to have at least one symbol or number, and have at least 8 characters.': '您的密码必须至少包含一个符号或数字，并且至少包含8个字符。',
  'Old Password': '您当前的密码',
  'New Password': '您的新密码',
  'Confirm New Password': '重新输入新密码',

  //todo my account
  //todo parent
  'Family No': '家庭号码',
  "Father's Name": '父亲姓名',
  "Mother's Name": '母亲姓名',
  "Guardian's Name": '监护人姓名',
  'Please search to view the list...': '请搜索以查看列表',
  'Parent Status': '状态',
  'Fathers Personal Information': '父亲个人资料',
  'Mothers Personal Information': '母亲个人资料',
  'Guardians Personal Information': '监护人个人资料',
  'Middle Name': '中间名',
  'Employment Status': '就业状况',
  Occupation: '职业',
  Designation: '工作指定',
  'Home Tel No': '家庭电话',
  'Office Tel No': '办公电话',
  'Fax No': '传真号码',
  'MObile No': '手机号码',
  Nationality: '国籍',
  Religion: '宗教',
  'Identification Type': '身份证类型',
  'Identification No': '身份证号码',
  'Identification No Expiry Date': '身份证有效期',
  Race: '种族',
  'Marital Status': '婚姻状况',
  Working: '就业状况',
  'Fathers Local Residential Address': '父亲的当地居住地址',
  'Mothers Local Residential Address': '母亲的当地居住地址',
  'Address 1': '地址1',
  'Address 2': '地址2',
  'Address 3': '地址3',
  City: '城市',
  Country: '国家',
  'Postal Code': '邮政编码',
  'EtonHouse Staff': '伊顿员工',
  'Employee Name': '员工姓名',
  'Fathers Company Address': '父亲公司地址',
  'Mothers Company Address': '母亲公司地址',
  'Company Addressee Name': '公司收件人姓名',
  'Company Address 1': '公司地址1',
  'Company Address 2': '公司地址2',
  'Company Address 3': '公司地址3',
  'Company City': '公司所在城市',
  'Company Country': '公司所在国家',
  'Company Email': '公司电邮',
  'Company Postal Code': '公司邮政编码',
  'Working Commencement Date': '工作开始日期',
  'Invalid Email Address': '无效的邮件地址',
  Other: '其它',
  'Share My Email': '分享我的电子邮件',
  'Share My Mobile Number': '分享我的手机号码',
  'School Name': '学校名字',
  Child: '孩子',
  'Re-Active': '重新启动',
  //todo parent

  //todo event
  'VIEW BY': '查看者',
  'Upcoming Events': '即将举行的活动',
  Latest: '最新',
  Calendar: '日历',
  TODAY: '今天',
  Events: '活动',
  Monthly: '月',
  Weekly: '周',
  Daily: '日',
  Type: '类型',
  'Event Start Date': '活动开始日期',
  'Event End Date': '活动结束日期',
  'Created by': '创建者',
  'Event Overview': '活动概述',
  'Switch View': '切换视图',
  Today: '今日',
  'Error, please try again': '错误，请重试',
  'Event Removed': '活动已删除!', // 去除
  'Please choose another date': '请选择其他日期',
  'Email Address': '电子邮件',
  Join: '参加',
  Guest: '客人',
  'Copy Event': '复制活动',
  Tutorial: '教学',
  'My Calendar': '我的日历',
  'All Calendar': '全部日历',
  Postback: 'Postback',
  Copy: '复制',
  //todo event

  //todo Post_Updates_Component Page
  'Remove All File': '删除所有文件',
  'Content is required': '内容为必填项',
  'Please Select Student': '请选择学生!',
  'Post Submitted, activity will be active in a while': '帖子已提交，帖子将在一段时间内激活',
  'Please Login to submit post': '请登录以提交帖子',
  'Please fill in content': '请填写内容',
  CONTENT: '内容',
  'Please enter your content here': '请在这里输入您的内容',
  'Allow user comment': '允许用户发表评论?',
  'or select latest posted tags': '或选择最新发布的标签.',
  //todo Post_Updates_Component Page

  //todo postPortfolioComponent Page
  'Title is required': '标题为必填项',
  Observations: '观察记录',
  'Please enter your observations': '请输入您的观察记录',
  'Observations is required': '观察记录为必填项',
  'Class is required': '班级为必选项',
  'Developmental Goals': '学习目标',
  'Select Development Goals': '选择学习目标',
  'Select Learning Domain': '选择学习领域',
  'Select Learning Goal': '选择学习目标',
  'Select Knowledge, Skills and Dispositions (KSD)': '选择知识，技能和学习品质',
  'Select Development Goals (moment)': '选择学习领域',
  'Developmental Goals is required': '学习目标为必选项',
  'You have selected': '您已选择:',
  'Analysis & Reflection': '分析与反思',
  'Analysis & Reflection is required': '分析与反思为必填项',
  Domain: '领域',
  Goals: '目标',
  'Key Skill or CLD': '技能或CLD',
  'Portfolio added': '作品集已添加.',
  'Successfully Posted': '成功发布!',
  'Remove All': '全部去除',
  Analysis: '学习目标',
  'Analysis (moment)': '分析',
  'Analysis is required': '分析为必填项',
  'Enduring Themes': '持久的主题',
  'Enduring Themes is required': '持久的主题为必填项',
  'Big Ideas is required': '中心思想为必填项',
  'Research Question': '研究问题',
  //todo postPortfolioComponent Page

  //todo newStudentInfo Page
  School: '学校',
  CLevel: '级别',
  Information: '信息',
  //todo newStudentInfo Page

  //todo newInvoice Page
  'No record found': '没有找到记录',
  'Please try again later': '请稍后再试',
  History: '历史/记录',
  //todo newInvoice Page

  //todo myChild Page
  'Child Details': '孩子详细信息',
  'Children Information': '孩子信息',
  'Preferred Name': '首选名称',
  Gender: '性别',
  'Date of Birth': '生日日期', // 出生日期
  'Birth Place': '出生地点',
  Fin: 'Fin',
  'Fin Expiry Date': 'Fin的有效日期',
  'Birth Certificate': '出生证明',
  IC: '身份证',
  Passport: '护照',
  'Passport Expiry Date': '护照的有效日期',
  'Other Identification': '其它身份证明',
  'Additional Language': '附加语言',
  'Dietary Requirement': '饮食需求',
  'First Language Spoken': '说的第一语言',
  'Second Language Spoken': '说的第二语言',
  Membership: '会员',
  "Children's Local Residential Address": '孩子当地居住地址', // 儿童当地居住地址
  'Postal code required': '邮政编码必填项',
  'Address 1 required': '地址1必填项',
  Contact: '联系',
  '1st Emergency Contact': '第一紧急联系人',
  'Contact Person': '联系人',
  'Contact No': '联系人号码',
  'Contact Relation': '联系人关系',
  '2nd Emergency Contact': '第二紧急联系人',
  'Authorized Children Pickup': '授权接送孩子', // 儿童
  Billing: '帐单',
  'Billing Info': '帐单信息',
  Payer: '付款人',
  'Frequent Payments': '付款频率',
  CDA: 'CDA',
  Subsidy: '津贴',
  'Billing Address': '帐单地址',
  'Mobile No': '手机号码',
  'Email required or Email invalid format': '电子邮件必填或电子邮件格式无效',
  Medical: '医疗',
  'Medication Allergies List': '药物过敏清单',
  Medication: '药物',
  'Food Allergies List': '食物过敏清单',
  Food: '食物',
  "Student's Medical Details": '学生的医疗详细信息',
  'Major Ailments List': '主要疾病清单',
  'Name of Family Doctor': '家庭医生的姓名',
  'Clinic Address': '诊所地址',
  'Clinic Phone No': '诊所电话号码',
  'Identify No': '身份证号码',
  Relationship: '关系',
  Termly: '定期',
  'Manually Input': '手动输入',
  "Student's Local Residential Address": '学生的本地居住地址',
  'Academic Year Code': '学年代码',
  'Level Start Date': '班级开学日期',
  'Level End Date': '班级结束日期',
  'Please fill in all * fields & at least one of ** field': '请填写拥有*符号和至少一个**符号',
  'Records Successfully Saved': '记录保存成功',
  'Update Error - Please try again later': '更新错误-请稍后重试',
  'Please fill Medication and Remarks': '请填写药物和备注',
  'Please fill Food and Remarks': '请填写食物和备注',

  // Religion
  BUDDHISM: '佛教',
  OTHERS: '其他',
  HINDU: '印度教',
  SIKHS: '西克斯',
  CHRISTIAN: '基督教',
  MUSLIM: '穆斯林',
  JAINS: 'JAINS',

  // Mother Tongue
  Bilingual: '双语',
  Hindi: '印度语',
  'Mandarin (Foreign)': '普通话（外国）',
  10: '10',
  'Mandarin (Local) Level 2': '普通话（本地）2级',
  'Mandarin (Local & Presap)': '普通话（本地和Presap）',
  Mandarin: '普通话',
  EAL: 'EAL',
  'EAL Intensive': 'EAL强化',
  Japanese: '日语',

  // Mother Tongue
  'Packed lunch': '盒装午餐',
  'School meal - Normal': '学校餐-普通',
  'School meal - Special': '学校餐-特别',
  Vegetarian: '素食',
  Vegan: '纯素',
  Standard: '标准餐',
  Asian: '亚洲餐',
  Hindu: '印度餐',
  Jain: 'Jain餐',
  'School meal - Vegetarian': '学校餐-素食',

  // Sponsorship Type
  'Father Company': '父亲公司',
  'Mother Company': '母亲公司',

  // Subsidies
  'Additional Subsidy': '额外补贴',
  'Child Care Subsidy': '育儿补贴',
  'Working Mother Subsidy': '在职母亲补贴',
  //todo myChild Page

  //todo Event_Modal_Component Page
  'Send Email Invitation': '发送电子邮件邀请',
  ETo: '到',
  'Start Date': '开始日期',
  'End Date': '结束日期',
  'Allow Parent Sign Up': '允许家长报名？',
  'Event Details': '活动详情',
  'Maximum Participants': '参加人数上限',
  'Registration Cutoff (Days)': '注册截止时间 (天)',
  'Event Registration Time': '报名时间',
  Duration: '活动时间',
  hour: '小时',
  Location: '地点',
  Tagged: '添加',
  'Add External Participant': '添加外来者',
  'Please enter participant emails separated by commas': '请输入参与者电子邮件，以逗号分隔',
  'Parent Teacher Conference': '家长教师会议',
  'School Closure': '学校停课',
  'Public Holiday': '公共假期',
  'Open Day': '开放日',
  'Term Break': '学期休息',
  'School Holiday': '学校假期',
  'Please insert event title': '请输入活动标题.',
  'Please select date from': '请选择日期.',
  'Please select event type': '请选择活动类型.',
  'Please insert location': '请输入位置.',
  'Please insert maximum participants': '请输入参加人数上限.',
  'Please insert registration cutoff (days)': '请输入注册截止时间 (天).',
  'Please insert registration time': '请输入报名时间.',
  'Event Added': '活动已添加!',
  'Maximum participants should not lower than registered pax': '参加人数上限不得低于注册人数',
  'Event update successful': '活动更新成功',
  'Email duplicated': '电子邮件重复',
  'Please insert valid email': '请输入有效的电子邮件',
  'File limit exceeded 2MB': '文件大小超过2MB!',
  'File Format Not Accepted': '文件格式不被接受!',
  'Add Conferencing': 'Add Conferencing',
  Elearning: '线上学习',
  'Select Start Datetime': '选择开始日期时间',
  'Select End Datetime': '选择结束日期时间',
  'End datetime cannot smaller than start datetime': 'End datetime cannot smaller than start datetime!',
  min: '分钟',
  'View time slot details': '查看时段详细信息',
  'Google Meet Link': 'Google Meet Link',
  'Select date range': '选择日期范围',
  'Start Time': '开始时间',
  'Select Start Time': '选择开始时间',
  'Select End Time': '选择结束时间',
  'Creator Name': '创建者姓名',
  'Created On': '创建于',
  'Allow Select Weekend': '允许选择周末',
  //todo Event_Modal_Component Page

  //todo EventBlastEmail Page
  'Number of guest': '客人人数',
  'Participant Deleted': '已删除该参加者',
  'Email Sent': '已发送至该邮件',
  //todo EventBlastEmail Page

  //todo Event_ParentModal_Component Page
  'Hosted By': 'Hosted By',
  Time: '时间',
  INVITATION: '邀请函',
  'Guest Pax': '来客人数',
  'Event Registered': '活动已注册!',
  'Select Timeslot': 'Select Timeslot',
  'Reset Email Password': 'Reset Email Password',
  'Delete Confirmation': '删除确认',
  Successful: '成功',
  'Delete Error': '删除错误',
  'Selected Timeslot Date Time': '所选时段日期时间',
  'All timeslots are booked': '所有时间段已被预订！',
  'Are you sure want to reset student gmail password': 'Are you sure want to reset student gmail password?',
  'Are you sure want to unselect this timeslot': '您确定要取消选择该时间段吗？',
  //todo Event_ParentModal_Component Page

  //todo PortfolioDetails Page
  Prev: '上一页',
  Next: '下一页',
  'Finding Out': 'Finding Out',
  'Date of observation': 'Date of observation',
  'Connection with long-term goals': '与长期目标相联系',
  'Anecdotal Observations': 'Anecdotal Observations',
  'Learning Journeys Name': '学习历程的名称',
  'Class Name': '班级名称',
  //todo PortfolioDetails Page

  //todo Portfolio Page
  'Select a class': '选择班级',
  'Select a student': '选择学生',
  'No student selected': '没有选择学生',
  'No updates posted for this student': '暂无内容',
  'Documenting Learning Journeys': '记录学习之旅',
  'View Progress': '查看进度',
  Selection: 'Selection',
  'Date and Time': 'Date and Time',
  Approved: '已批准',
  'Review Required': '需要审查',
  'Learning Journeys': '学习之旅',
  'observations selected': '选择观察记录',
  Progress: '进展',
  'Learning Journey Term and Big Ideas/Enduring Themes': '主要概念，中心思想/持久性主题',
  'Please select Term, Please select Big Ideas/Enduring Themes': '请选择学期，请选择中心思想/持久性主题',
  'Development Goals': 'Development Goals',
  'Rearrange Content': 'Rearrange Content',
  'Portfolio Description': 'Portfolio Description',
  //todo Portfolio Page

  //todo PlannerStudentProgress Page
  Posted: 'Posted ',
  'Posted Domains': 'Posted Domains',
  'No Posted': 'No Posted',
  'Pending Domains': 'Pending Domains',
  'No Pending': 'No Pending',
  'Posted Report': 'Posted Report',
  // "Select Academic Year": "Select Academic Year",
  'Select Term': '选择学期',
  'Posted Domains Whole Academic Year': 'Posted Domains Whole Academic Year',
  'Posted Domains Summary': 'Posted Domains Summary',
  'View More Details': 'View More Details',
  'Pending Domains Whole Academic Year': 'Pending Domains Whole Academic Year',
  'Pending Domains Summary': 'Pending Domains Summary',
  'Pending Domain Details Whole Academic Year': 'Pending Domain Details Whole Academic Year',
  'Posted Domain Details Whole Academic Year': 'Posted Domain Details Whole Academic Year',
  'Pending Domain Details': 'Pending Domain Details',
  'Posted Domain Details': 'Posted Domain Details',
  Done: 'Done',
  Assign: '设定',
  //todo PlannerStudentProgress Page

  //todo PortfolioPreview Page
  'Portfolio Edit': 'Portfolio Edit',
  'Portfolio Name': 'Portfolio Name',
  'Enduring Themes/Transdisciplinary Themes': '持久的主题/跨学科的主题',
  'No Remark Yet': 'No Remark Yet',
  Commenter: 'Commenter',
  'Research Question(s)/Unit(s) of Inquiry': '探究问题/探究单元',
  Approve: '批准',
  Reject: '驳回',
  Rejected: '未通过审核',
  'Inquiry Cycle': '探究环节',
  'Date of Commenter': 'Date of Commenter',
  'Learning Journey Submitted Successfully': '学习之旅提交成功',
  'Please fill up all content': 'Please fill up all content',
  'Please fill in all fields': 'Please fill in all fields',
  'Cover Page': '封面',
  'Purpose of Learning Journey': '学习之旅的目标',
  'Programme of Inquiry/Intended Projects': '探究项目',
  'Big Ideas': '中心思想',
  'Key Concepts': '主要概念',
  'Learner Profiles': '学习者培养目标',
  "Child's Self-Portrait/Photo": '幼儿的自画像/照片',
  'Upload from gallery': 'Upload from gallery',
  'Core Concepts': 'Core Concepts',
  'Save as draft': 'Save as draft',
  //todo PortfolioPreview Page

  //todo EventPostBack Page
  Files: 'Files',
  //todo EventPostBack Page

  //todo NavButton Page
  'News Feed': '动态消息',
  'Termly Report': '总结报告',
  Planner: '计划书',
  'Daily Log': '日志',
  'Declaration Form': '申报表格',
  Survey: '调查表',
  //todo NavButton Page

  //todo MainLibrary Page
  Publish: '发布',
  Published: '已发布',
  'Added to post': '添加到帖子',
  Library: '图库',
  'Search Library': '搜索图库',
  'Select Directory': '选择目录',
  'Create New Folder': '创建新文件夹',
  'Move To Editor': '移至编辑器',
  'Not found related files': '找不到相关文件！',
  //todo MainLibrary Page

  //todo StaffFeed Page
  'Search Feed': '搜索动态消息',
  'Parent Info': '家长信息',
  'Father Name': '父亲姓名',
  'Mother Name': '母亲名字',
  'Student Info': '学生资料',
  'Student School': '学生所在学校',
  'Student Class': '学生所在班',
  'Student Level': '学生所在班级',
  'Filter by': '筛选',
  //todo StaffFeed Page

  //todo StaffMoment Page
  'New Moments': 'New Moments',
  'Draft List': '草稿列表',
  Draft: '草稿',
  'Moments Not Found': 'Moments Not Found!',
  'Select Class and Student': '请选择一个班级和学生',
  'Next Step': '下一页',
  'Previous Step': '上一页',
  'Select Indicator': '选择指标',
  Indicator: '指标',
  'Fill in Title and Indicator': '请填写标题和指标',
  text: '文体',
  layers: '层级',
  width: '宽度',
  height: '高度',
  horizontal: '水平对齐',
  vertical: '垂直对齐',
  'line height': '行高',
  'font size': '字号',
  color: '颜色',
  bold: '加粗',
  align: '对齐',
  tools: '可用组件',
  'selected tools': '已加组件',
  settings: '参数',
  interaction: '交互',
  onclick: '点击时',
  link: '链接至',
  background: '页面背景色',
  picture: '图片',
  //todo StaffMoment Page

  //todo Post_Broadcast_Component Page
  Subject: '标题',
  'Please enter a subject': '请输入标题',
  'Please enter a message': '请输入信息',
  //todo Post_Broadcast_Component Page

  //todo MainNotificationComponent
  'You have Message': '您有留言!',
  //todo MainNotificationComponent

  //todo TermlyReport
  'Create New': '创建',
  'Report List': '总结报告列表',
  'Termly Report List': '总结报告列表',
  'Back To List': '返回列表',
  'New Termly Report': '新学期报告',
  'Name of child': '幼儿姓名',
  'Student Join Date': '加入伊顿的时间',
  'Current Age': '年龄',
  'Period of Report': '报告时间段',
  'Date of Birth': '生日',
  Class: '班级',
  'Summary of In School Learning': '学校学习总结',
  'Comments from the Languge Specialist Teachers': '语言科老师的评论',
  'Post Lists': '发布列表',
  'No Post Found': '无发布',
  'Search Title': '搜索标题',
  'Published Report': '已公布的报告',
  'View By List': '以列表查看',
  'View By Post': '以帖子查看',
  'Pending Action': '待处理',
  //todo TermlyReport

  // plannerstudentassign
  'Learning Goals List': '学习目标列表',
  'Learning Goals': '学习目标',
  'Other List': '其他学习目标列表',
  'Other Level List': '其他学年学习目标列表',
  'New List': '添加新的学习目标',
  Suggested: '推荐',
  'Other Level': '其他学年',
  'Search Indicator': '搜索学习指标',
  // "Indicator": "学习指标",
  Goals: '学习目标',
  Domain: '学习领域',
  'Filter By': '筛选学习领域',
  'Filter Type': '筛选种类',
  'Filter Level': '筛选等级',
  'Number of Learning Goals Assigned': '已设置学习目标',
  View: '查看',
  'Learning goal documented for this academic year': '今年已完成的学习目标',
  'Learning goal documented Summary': '已完成学习目标总结',
  'Learning goals to be documented for this academic year': '今年未完成的学习目标',
  'Learning goals to be documented Summary': '未完成学习目标总结',
  'Learning goal documented': '已完成的学习目标',
  'Learning goal documented Summary': '已完成的学习目标总结',
  'Learning goals to be documented': '未完成学习目标',
  'Learning goals to be documented Summary': '未完成学习目标总结',
  Tracker: '学生学习进度',
  'No learning goal documented': '未完成学习目标',
  'Show Whole Academic Year': '显示全年学习目标',
  'Hide Whole Academic Year': '掩藏全年学习目标',
  'No learning goals to be documented': '未完成学习目标',
  'Select Academic Year': '选着学年',

  'Align left': '左对齐',
  'Align center': '居中',
  'Align justify': '对齐',
  'Align right': '右对齐',
  // plannerstudentassign

  //todo Portfolio_Component
  'Delete Selected Item': '删除所选物件',
  //todo Portfolio_Component

  //todo NewMyAccount
  'Enable / Disable receive email reminder for new update': '启用/禁用接收电子邮件提醒以进行新更新',
  'Your password needs to have at least 6 characters': '您的密码必须至少包含6个字符。',
  'Back to main page': '返回主页',
  Account: '帐户',
  'Edit and manage your account details': '编辑和管理您的帐户详细信息',
  'Upload Profile Image': '上传个人图片',
  'BROWSE IMAGE': '浏览图像',
  //todo NewMyAccount

  //todo Activity
  'My Newsfeeds': '班级动态（个人）',
  'My Moments': '学习之旅（个人）',
  'All Posts': '班级动态',
  'All Moments': '学习之旅',
  'All Broadcasts': '公告',
  'Search Post': '搜索帖子',
  'Search multiple keywords': '注意：多个关键词之间以逗号分隔',
  'Search Example': '搜索示例: ABC, water play, new year celebration',
  'Showing To': '显示给：',
  'Show Less': '显示较少',
  'Show All': '显示所有',
  Tags: '标签',
  'Modified on': '修改日期',
  'Post Type': '帖子类型',
  Level2: '年级',
  'Select Teacher': '选择老师',
  'Filter Post': '筛选帖子',
  'Clear All': '全清',
  'Preview Post': '预览帖子',
  'Are you sure you want to delete this post?': '确定删除帖子吗？',
  'Are you sure to leave this page?': '确定离开此页吗？',
  'Create New Post': '创建帖子',
  'Load From Template': '加载模板',
  'Load From Draft': '加载草稿',
  'Select Post Type': '选择帖子类型',
  Feeds: '班级动态',
  Broadcasts: '公告',
  Moments: '学习之旅',
  Newsfeed: '班级动态',
  Rearrange: '重新排列',
  Browse: '浏览',
  Replace: '替换',
  'Upload files max allow 5 each time': '每次最多上传五个文件。',
  'File with invalid format selected': '文件格式错误，请选择有效格式',
  'Selected Student': '已选学生',
  'Selected Levels': '已选年级',
  'Selected Classes': '已选班级',
  LEVEL: '年级',
  CLASS: '班级',
  'Please input your remarks': '输入备注',
  'Save Draft': '保存为草稿',
  'Are you sure you want to discard the content and back to activity page?': '确定放弃发布，并回到活动页吗？',
  'Publish on': '发布日期',
  'Schedule post': '定时发布',
  'Publish Now': '立即发布',
  'Pick a date': '选择日期',
  'Save as template': '保存为模板',
  'Submit Post': '发布帖子',
  'Save Template': '保存模板',
  'Please Insert Post Title': '请输入帖子标题',
  'Please Insert Post Content': '请输入帖子内容',
  'Please Select Post Type': '请选择帖子类型',
  'Video Uploading': '视频上传中',
  'will be active in a while': '文件稍后将完成上传。',
  activity: 'activity',
  'Post Updated': '帖子已更新',
  'Draft Saved': '草稿已保存',
  'Please enter tags name': '输入标签名称',
  'Select Template': '选择模板',
  'Select Draft': '选择草稿',
  Use: '选择',
  'Are you sure you want to discard this template': '确定删除此模板吗？',
  'Show More': '显示更多',
  'Insert content here': '输入详情...',
  'Reaction by': 'Reaction by',
  // "Intended Project Update":"探究的进展",
  'Intended Project Update': '进展',
  'Suggestions for Home-School Connection': '家园合作建议',
  'Language and Literacy Focus': '语言和读写能力',
  'Numeracy Focus': '数概念',
  Context: '观察背景',
  Observation: '观察记录',
  'Please select a minimum of 3 Developmental Goals for the Analysis': '为了撰写分析，请至少选择三个发展目标',
  'Please select a minimum of 2 Learning Domains': '请至少选择两个学习领域',
  //todo Activity

  //todo Planner
  GoalPlanner: '目标计划表',
  'Planner Assign Student': 'Planner Assign Student',
  'Planner Master': 'Planner Master',
  'New Master Planner': 'New Master Planner',
  'Assign Planner': 'Assign Planner',
  'Search Level': 'Search Level',
  'Search Domain': 'Search Domain',
  OTHER: 'OTHER',
  'NEL Goals': 'NEL Goals',
  'ITL NEL Goals': 'ITL NEL Goals',
  IndicatorType: 'IndicatorType',
  'New Planner Master': 'New Planner Master',
  'Select Level': '选择年级',
  'Select Type': 'Select Type',
  'Fill in new Domain': 'Fill in new Domain',
  'Indicator Type': 'Indicator Type',
  Language: 'Language',
  'Select Language': 'Select Language',
  'Select School Type': 'Select School Type',
  'Select School': 'Select School',
  'School Type': 'School Type',
  'Un-Assign Planner': 'Un-Assign Planner',
  'Assigned Planner': 'Assigned Planner',
  'Planner Assigned': 'Planner Assigned',
  'Course Type': 'Course Type',
  'All Fields Required': 'All Fields Required',
  'Get Master Planner List: Error': 'Get Master Planner List: Error',
  'Save Master Planner List: Error': 'Save Master Planner List: Error',
  'Planner duplicated': 'Planner duplicated',
  'Delete Master Planner List: Error': 'Delete Master Planner List: Error',
  'Get Master Planner List Group By Domain: Error': 'Get Master Planner List Group By Domain: Error',
  'Delete Assigned Planner List: Error': 'Delete Assigned Planner List: Error',
  'Save Planner Details: Error': 'Save Planner Details: Error',
  'Get Un-Assign Planner List: Error': 'Get Un-Assign Planner List: Error',
  'Get Assigned Planner List: Error': 'Get Assigned Planner List: Error',
  'Get Planner Assigned To School List: Error': 'Get Planner Assigned To School List: Error',
  Term: 'Term',
  'Level Goals': '年级目标和发展指标',
  'Other Goals': '定制发展指标',
  'No Custom Goals': '未添加发展指标',
  'Custom Goals': 'Custom Goals',
  'Course Name': '年级',
  'No of assigned Goals': '已设定发展指标总数',
  'Please select Class & Term': 'Please select Class & Term...',
  'Class Goals Details: ERROR!!': 'Class Goals Details: ERROR!!',
  'Successfully Save': 'Successfully Save...',
  'The goal already exist in the list': 'The goal already exist in the list',
  'Add Custom Goals': '添加定制发展指标',
  'Select a class to start': '选择班级，开始设定学习目标',
  'Goal Planner': '目标计划表',
  'Enter Indicator': 'Enter Indicator ',
  'Goal:': '目标：',
  'Goal Indicator': '发展指标：',
  'Term 1': '第一学期',
  'Term 2': '第二学期',
  'Term 3': '第三学期',
  'Term 4': '第四学期',

  'Level Goal Planner': '年级目标计划表',
  'Level Assign': '为年级设定',
  'Level Goal Back': '年级列表',
  'New Class goals': 'New Class goals',
  'Select Domain': 'Select Domain',
  'Select Goal': 'Select Goal',
  //todo Planner

  //todo Navigation
  'Newsfeed / Moment / Broadcast': '班级动态 / 学习之旅 / 公告',
  'Planner setup by class and student ': '年级和学生计划表',
  'View Student Progress ': '学生进度',

  //todo Navigation
}

export default CN
